import {AfterViewInit, Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {FullChild} from "../../../../../interfaces/FullChild";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../../interfaces/Centres";
import {MatSelectChange} from "@angular/material/select";
import {ChildService} from "../../../../../components/child/child.service";
import {CentreService} from "../../../../../services/centre.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import firebase from "firebase/compat/app";
import {UserData} from "../../../../../auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {EditHighlightItemComponent} from "../edit-highlight-item/edit-highlight-item.component";
import Editor from "@ckeditor/ckeditor5-build-classic";
import {LogService} from "../../../../../services/log.service";


@Component({
  selector: 'app-add-heighlight',
  templateUrl: './add-heighlight.component.html',
  styleUrls: ['./add-heighlight.component.scss']
})
export class AddHeighlightComponent implements OnInit, OnDestroy, AfterViewInit {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  @ViewChild(MatSort) sort!: MatSort;
  dataSource = new MatTableDataSource<any>([]);

  highlightForm!: FormGroup;
  editMode: boolean = false;
  mSelectedCentre: any;
  selectedChildId: FullChild | undefined;
  mChildren!: FullChild[];
  centres$!: Observable<Centre[]>;
  children$?: Observable<FullChild[]>
  narrative: string = '';
  firstName: any;
  lastName: any;
  highlighTypeList$!: Observable<any[]>
  userData: UserData = JSON.parse(localStorage.getItem('userData')!) as UserData
  childControl = new FormControl('', Validators.required);
  highlightId!: string | null;
  mHightlights: any[] = []
  displayedColumns = ['position', 'addedBy', 'centreCode', 'childName', 'narrative', 'highlight', 'createdAt', 'action']
  maxDate = new Date();

  constructor(private readonly childService: ChildService,
              private readonly mFirestore: AngularFirestore,
              private mDatabase: AngularFireDatabase,
              private readonly mDialog: MatDialog,
              private readonly mDatabas: AngularFireDatabase,
              private fb: FormBuilder,
              private _snackBar: MatSnackBar,
              private mRouter: Router,
              private mLogService: LogService,
              private route: ActivatedRoute,
              private readonly mCentreService: CentreService) {
    console.log(this.userData)
    // this.setAddedBy(this.userData?.userName)
    // this.setAddedbyEmail(this.userData.email)
    // alert(`${this.userData?.userName} with email ${this.userData.email}`);
    this.centres$ = this.mCentreService.getAllCentres();
    this.highlighTypeList$ = mDatabase.list<any>('types/Highlights Type').valueChanges();
  }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (item, property) =>
      property === 'createdAt' ? (item.createdAt?.toDate?.().getTime() ?? 0) : item[property];
    this.initializeForm();
    // Check if there is an ID in the route (edit mode)
    this.route.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      this.highlightId = params.get('id');
      if (this.highlightId) {
        this.editMode = true;
        this.loadHighlightData(this.highlightId);
      }
    });
    if (this?.userData) {
      this.highlightForm.patchValue({
        addedBy: this.userData?.userName,
        addedbyEmail: this.userData?.email,
      });
    }

  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }


  private loadHighlightData(highlightId: string) {
    this.mFirestore
      .collection(this.env.highlights)
      .doc(highlightId)
      .get()
      .pipe(takeUntil(this._destroyed$))
      .subscribe(doc => {
        if (doc.exists) {
          const data: any = doc.data();
          if (data) {
            console.log('Hightlights', data)
            this.mHightlights = data.highlights
            const h:any[] = this.mHightlights
            // Patch top-level fields
            this.highlightForm.patchValue({
              childName: data.childName,
              childCode: data.childCode,
              centreCode: data.centreCode,
              narrative: data.narrative,
              eventDate: data.eventDate.toDate(),
            });
            this.highlightForm.setValue({
              narrative: data.narrative,
            })

            if (data.highlights && data.highlights.length > 0) {
              this.setHighLightsTable(data.highlights)
              const firstHighlight = data.highlights;

              // Patch the highlight-specific fields into the form
              this.highlightForm.patchValue({
                highlight: firstHighlight.highlight,
                narrative: firstHighlight.narrative,
                createdAt: firstHighlight.createdAt,
                addedBy: firstHighlight.addedBy,
                addedbyEmail: firstHighlight.addedbyEmail,
              });
            }

          }
        }
      });
  }

  private initializeForm() {
    this.highlightForm = this.fb.group({
      childName: ['', Validators.required],
      addedBy: ['', Validators.required],
      addedbyEmail: ['', Validators.required],
      centreCode: ['', Validators.required],
      childCode: ['', Validators.required],
      highlight: [''],
      narrative: [''],
      eventDate: ['', Validators.required],
      createdAt: [new Date()],
    });
  }

  onCentreSelected($event: MatSelectChange): void {
    this.mChildren = []
    this.mSelectedCentre = $event.value;
    this.children$ = this.childService.getAllotedChildListByCenterAboveThree(this.mSelectedCentre)
    this.children$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      res.forEach(c => {
        this.mChildren.push(c)
      })
    })
  }

  setChildName(string: string) {
    this.highlightForm.get('childName')?.setValue(string);
  }


  setChildCode(string: string) {
    this.highlightForm.get('childCode')?.setValue(string);
  }

  get getChildCode() {
    return this.highlightForm.value.childCode
  }


  get getCentre() {
    return this.highlightForm.value.centreCode
  }

  onChildSelect($event: MatSelectChange): void {
    this.selectedChildId = $event.value;
    // this.setChildName($event.value?.firstName+' '+$event.value?.lastName)
    this.setChildName(`${$event.value?.firstName ?? ''} ${$event.value?.lastName ?? ''}`.trim());

    this.setChildCode(this.selectedChildId?.childCode!!)
  }

  onSubmit() {
    if (this.highlightForm.valid) {
      if (this.highlightId) {
        if (!this.highlightId) {
          console.error('No highlight ID provided for update.');
          return;
        }

        // Prepare the updated data object
        const updatedData: any = {
          childName: this.highlightForm.value.childName,
          childCode: this.highlightForm.value.childCode,
          centreCode: this.highlightForm.value.centreCode,
          narrative: this.highlightForm.value.narrative,
          eventDate: this.highlightForm.value.eventDate ? new Date(this.highlightForm.value.eventDate) : null,
        };

        // If there are highlights, update the first highlight
        if (this.highlightForm.value.highlight) {
          updatedData.highlights = [
            {
              highlight: this.highlightForm.value.highlight,
              narrative: this.highlightForm.value.narrative,
              addedBy: this.highlightForm.value.addedBy,
              addedbyEmail: this.highlightForm.value.addedbyEmail,
              createdAt: new Date(), // Update createdAt with the current timestamp
              eventDate: this.highlightForm.value.eventDate ? new Date(this.highlightForm.value.eventDate) : null,
            },
          ];
        }

        // Firestore update operation
        this.mFirestore
          .collection(this.env.highlights)
          .doc(this.highlightId)
          .update(updatedData)
          .then(() => {
            console.log('Highlight updated successfully');
            this._snackBar.open('Highlight updated successfully!', 'Close', {duration: 3000});
            this.mRouter.navigateByUrl('home/reports/highlight');
          })
          .catch(error => {
            console.error('Error updating highlight:', error);
            this._snackBar.open('Failed to update highlight.', 'Close', {duration: 3000});
          });
      } else {
        const childId: string = this.getChildCode;
        this.mFirestore.collection(this.env.highlights).doc(childId)
          .set({
              childCode: childId,
              centreCode: this.getCentre,
              childName: this.highlightForm.value.childName,
              narrative: this.highlightForm.value.narrative,
              eventDate: this.highlightForm.value.eventDate,
              highlights: firebase.firestore.FieldValue.arrayUnion(this.highlightForm.value),
            }, {merge: true}
          ).then(() => {

          // ⭐ ADD ACTIVITY LOG
          const activity = {
            date: new Date().getTime(),
            section: 'Child Highlight',
            action: 'Submit',
            description: `Highlight added for child: ${this.highlightForm.value.childName}`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          this._snackBar.open('Highlight added successfully!', 'Close', {
            duration: 3000,
            panelClass: ['success-snackbar'],
          });
          this.mRouter.navigateByUrl('home/reports/highlight');
        }).catch(error => {
          console.error('Error saving highlight:', error);
        });
      }

    }


  }


  cancel() {
    this.mRouter.navigateByUrl('home/reports/highlight');
  }

  private setHighLightsTable(highlights: any[]) {
    this.mHightlights = highlights
    this.dataSource.data = this.mHightlights
  }

  editDialog(element: any, position: number) {
    this.mDialog.open(
      EditHighlightItemComponent,
      {
        data: {
          highlight: element,
          position: position
        }
      }
    ).afterClosed().subscribe(res => {
      this.mHightlights[position].narrative = this.mHightlights[position].narrative.toString();
      this.dataSource.data = this.mHightlights
      this.mFirestore.collection(this.env.highlights).doc(this.highlightId!!)
        .update({
          "highlights": this.mHightlights
        })
        .then(() => {

          // ⭐ ADD ACTIVITY LOG
          const activity = {
            date: new Date().getTime(),
            section: 'Child Highlight',
            action: 'Update',
            description: `Edited highlight item for child: ${this.highlightForm.value.childName}`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          this._snackBar.open('Update Successful', '', {
            duration: 3000,
            panelClass: 'snackbar-success'
          });
        })

        .catch((err) => {
          console.error(err);
          this._snackBar.open('Error while updating: ' + err.message, "ERROR", {
            duration: 3000,
            panelClass: 'snackbar-error'
          });
        });
      }
    )

  }
  deleteItem(element: any, index: number) {
    if (confirm('Are you sure you want to delete this item?')) {
      this.mHightlights.splice(index, 1);
      this.dataSource.data = this.mHightlights
      // Update Firestore with the updated array
      this.mFirestore.collection(this.env.highlights).doc(this.highlightId!!)
        .update({ highlights: this.mHightlights })
        .then(() => {

          // ADD ACTIVITY LOG
          const activity = {
            date: new Date().getTime(),
            section: 'Child Highlight',
            action: 'Delete',
            description: `Deleted a highlight item for child: ${this.highlightForm.value.childName}`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          this._snackBar.open('Deleted successfully!', '', {
            duration: 3000,
            panelClass: 'snackbar-success'
          });
        })

        .catch((error) => {
          console.error('Error deleting item: ', error);
          this._snackBar.open('Error deleting: ' + error.message, 'ERROR', {
            duration: 3000,
            panelClass: 'snackbar-error'
          });
        });
    }
  }

  protected readonly Editor = Editor;
}
